import React, { useEffect, useState, useRef } from 'react';
import { baseURL, sistemaURL } from '../url.js';
import '../../css/Components/ProductsMore/ProductsMore.css';
//import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper/core';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
//import SwiperCore from 'swiper/core';
import { Swiper, SwiperSlide } from 'swiper/react';
//import 'swiper/swiper-bundle.css';
/*import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import 'swiper/css/effect-coverflow';*/
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight, faStar } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ProductosLoading from '../ProductosLoading/ProductosLoading';
import { Link as Anchor } from "react-router-dom";
import moneda from '../moneda.js';
import { useMediaQuery } from '@react-hook/media-query';
import { renderNumero } from '../../js/funcionesGenerales.js';
//SwiperCore.use([Navigation, Pagination, Autoplay]);

export default function ProductsMore() {
    const [loading, setLoading] = useState(true);
    const swiperRef = useRef(null);
    const [productos, setProductos] = useState([]);

    const isScreenLarge = useMediaQuery('(min-width: 900px)');


    useEffect(() => {
        cargarProductos();
    }, []);


    const cargarProductos = () => {
        fetch(`${sistemaURL}/web/getMasVendidos?l=10`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setProductos(data);
                setLoading(false);
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const obtenerImagen = (item) => {
        return `${sistemaURL}assets/images/imagenesArticulos/${item.imagen1 || "sinimagen.jpg"}`
    };
    return (
        <div className='ProductsMore'>
            {loading ? (
                <div className='categoriSection'>     <ProductosLoading /></div>
            ) : (
                <div >
                    <div className='categoriSection'>
                        <Swiper
                            modules={[Navigation, Pagination, Autoplay]}
                            effect="coverflow"
                            grabCursor={true}
                            slidesPerView="auto"
                            id="swiper_container_productsMore"
                            autoplay={{ delay: 3000 }} >
                            {productos?.map(item => (
                                <SwiperSlide key={item.id} id="SwiperSlide-scroll-products-masvendidos">
                                    <Anchor className="cardProdcutmasVendido" to={`/producto/${item.id}/${item.nombre.replace(/\s+/g, '-')}`}title={item.nombre} >
                                        <img src={obtenerImagen(item)} alt="imagen" />
                                        <h6 className="masVendido">Más Vendido</h6>
                                        <div className="cardText"> <h4>{item.nombre}</h4>
                                            {/* <span>{item.descripcion}</span> */}
                                            {/* <div dangerouslySetInnerHTML={{ __html: item.descripcion }} /> */}
                                            <div className="deFLexPrice">
                                                <h5>{moneda} {renderNumero(item?.precio_unitario_soles)}</h5>
                                            </div>
                                        </div>
                                        <FontAwesomeIcon icon={faAngleDoubleRight} className="iconCard" />
                                    </Anchor>
                                </SwiperSlide>))}
                        </Swiper>
                    </div >

                    <Swiper id='swiperBg'>

                    </Swiper>
                    {/* {(item.precioAnterior >= 1 && item.precioAnterior !== undefined) && (
                                                    <h5 className='precioTachado'>{moneda} {`${item?.precioAnterior}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                                                )} */}
                </div >
            )}
        </div >
    );
}
